function genderEnglish2Persian(gender: string) {
  switch (gender) {
    case "MALE":
      return "مرد";
    case "FEMALE":
      return "زن";
    default:
      return gender;
  }
}

export default genderEnglish2Persian